import { Directive, AfterViewInit, Input, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: '[artemisKeywordHighlighter]'
})
export class KeywordHighlighterDirective implements AfterViewInit {

  _keywordList: Array<string>;

  @Input() set keywordList(value: Array<string>) {
    if (value) {
      this._keywordList = value;
    }
  }

  get keywordList() {
    return this._keywordList;
  }

  constructor(private renderer: Renderer2,
              private elementRef: ElementRef) { }

  ngAfterViewInit() {
    this.highlightKeyword();
  }

  highlightKeyword(): void {
    this.keywordList.forEach((keyword: string) => {
      const matchRegEep = new RegExp(keyword, 'ig');
      this.renderer.setProperty(
        this.elementRef.nativeElement,
        'innerHTML',
        this.elementRef.nativeElement.innerHTML.replace(matchRegEep, '<span class="highlight">' + keyword + '</span>')
      );
    });
  }
}
